export default "__VITE_ASSET__BQIelPAQ__"